module.exports = __webpack_public_path__ + "static/media/BiSharesFooterLogo.07895b6d.png";